// src/services/authService.js
import API from '../services/api'; // adjust path as needed

export const loginUser = async (email, password) => {
  const response = await API.post('/auth/login', { email, password });
  return response.data; // Axios automatically parses JSON
};
// src/services/auth.js


export const authService = {
  registerTechnician: async (formData) => {
    try {
      const response = await API.post('/auth/register', {
        ...formData,
        role: 'technician'
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
};